import { ReactNode } from "react";

const CenterWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );
};

export default CenterWrapper;
